import { Injectable } from '@angular/core';
import { CommonSettings } from 'epay-library';
import {
  HttpHeaderResponse,
  HttpHeaders,
  HttpParams,
  HttpClient,
  HttpErrorResponse,
} from '@angular/common/http';
import { IEmpSearchResults } from 'epay-library';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EmployerService {
  private serviceurl = CommonSettings.BaseApi;
  private environment = CommonSettings.Environment;
  private ecomGateway = 'EcommerceGateway/Ecommmerce';

  HttpOptions = {
    headers: new HttpHeaders(),
    params: new HttpParams(),
  };

  constructor(private http: HttpClient) {}

  getEmployerTerms() {
    const file = 'assets/terms/employer/disclaimer.txt';
    return this.http
      .get(file, { responseType: 'text' })
      .pipe(catchError(this.handleError));
  }

  getEFTInfo() {
    const file = 'assets/information/eft.html';
    return this.http
      .get(file, { responseType: 'text' })
      .pipe(catchError(this.handleError));
  }

  getACHDInfo() {
    const file = 'assets/information/achd.html';
    return this.http
      .get(file, { responseType: 'text' })
      .pipe(catchError(this.handleError));
  }

  getLoginHelp() {
    const file = 'assets/help/loginHelp.html';
    return this.http
      .get(file, { responseType: 'text' })
      .pipe(catchError(this.handleError));
  }

  private handleError(err: HttpErrorResponse) {
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
    }
    console.log(errorMessage);
    return throwError(() => err);
  }
}
